import React, { useState } from 'react';
import Button from '../ui/Button';
import Input from '../ui/Input';

const ContractPreview = ({ 
  contract, 
  template, 
  onEdit, 
  onSaveTemplate, 
  onFinalize, 
  onBack, 
  onSubmitReview, 
  loading 
}) => {
  const [editedContent, setEditedContent] = useState(contract.contract_content);
  const [templateName, setTemplateName] = useState('');
  const [isPublic, setIsPublic] = useState(false);
  const [showSaveTemplate, setShowSaveTemplate] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [showReview, setShowReview] = useState(false);
  
  // Handle content changes
  const handleContentChange = (e) => {
    setEditedContent(e.target.value);
    onEdit(e.target.value);
  };
  
  // Handle save template
  const handleSaveTemplate = () => {
    if (templateName.trim()) {
      onSaveTemplate(templateName, isPublic);
      setShowSaveTemplate(false);
      setTemplateName('');
    }
  };
  
  // Handle rating click
  const handleRatingClick = (value) => {
    setRating(value);
  };
  
  // Handle submit review
  const handleSubmitReview = () => {
    if (rating > 0) {
      onSubmitReview(rating, feedback);
      setShowReview(false);
      setRating(0);
      setFeedback('');
    }
  };
  
  return (
    <div className="contract-preview">
      <h2>Review Your Contract</h2>
      <p>Review the generated contract below. You can make edits if needed before finalizing.</p>
      
      <div className="contract-preview-container">
        <textarea
          className="contract-editor"
          value={editedContent}
          onChange={handleContentChange}
          disabled={loading}
        />
        
        <div className="preview-actions">
          <Button 
            onClick={onBack} 
            variant="secondary"
            disabled={loading}
          >
            Back
          </Button>
          
          <div className="action-buttons">
            <Button 
              onClick={() => setShowSaveTemplate(true)} 
              variant="secondary"
              disabled={loading}
            >
              Save as Template
            </Button>
            
            <Button 
              onClick={() => setShowReview(true)} 
              variant="secondary"
              disabled={loading}
            >
              Rate Generation
            </Button>
            
            <Button 
              onClick={onFinalize}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Finalize & Sign'}
            </Button>
          </div>
        </div>
        
        {showSaveTemplate && (
          <div className="save-template-form">
            <h3>Save as Template</h3>
            <Input
              label="Template Name"
              type="text"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              required
            />
            
            <div className="checkbox-field" style={{ marginTop: '1rem', display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                id="isPublic"
                checked={isPublic}
                onChange={(e) => setIsPublic(e.target.checked)}
                style={{ marginRight: '0.5rem' }}
              />
              <label htmlFor="isPublic">Make this template public</label>
            </div>
            
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <Button 
                onClick={() => setShowSaveTemplate(false)} 
                variant="secondary"
              >
                Cancel
              </Button>
              <Button 
                onClick={handleSaveTemplate}
                disabled={!templateName.trim()}
              >
                Save Template
              </Button>
            </div>
          </div>
        )}
        
        {showReview && (
          <div className="review-section">
            <h3 className="review-title">Rate this Contract Generation</h3>
            
            <div className="star-rating">
              {[1, 2, 3, 4, 5].map((value) => (
                <span
                  key={value}
                  className={`star ${value <= rating ? 'filled' : ''}`}
                  onClick={() => handleRatingClick(value)}
                >
                  ★
                </span>
              ))}
            </div>
            
            <Input
              label="Feedback (Optional)"
              type="textarea"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Tell us what you think about the generated contract..."
            />
            
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
              <Button 
                onClick={() => setShowReview(false)} 
                variant="secondary"
              >
                Cancel
              </Button>
              <Button 
                onClick={handleSubmitReview}
                disabled={rating === 0}
              >
                Submit Review
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractPreview;
